import { useRouter } from '@tanstack/react-router'
import { Button, Card, Result } from 'antd'
import { FaHome } from 'react-icons/fa'

export function NotFoundErrorComponent() {
  const router = useRouter()

  return (
    <Card className="mx-auto">
      <Result
        status="404"
        title={<span className="text-2xl">Seite nicht gefunden</span>}
        subTitle={<span className="text-gray-600">Die angeforderte Seite existiert nicht oder wurde verschoben.</span>}
        extra={
          <div className="flex justify-center">
            <Button type="primary" icon={<FaHome />} onClick={() => void router.navigate({ to: '/' })}>
              Zur Startseite
            </Button>
          </div>
        }
      />
    </Card>
  )
}
